export default __webpack_public_path__ + "static/media/cultura_digital.6614fb25.pdf";